//react
import React, { useState, useEffect } from "react";

//css
import "./styles.css"

const AsteriskPositions = {
  RIGHT: "RIGHT",
  LEFT: "LEFT",
};

const AsteriskColors = {
  RED: "RED",
  BLUE: "BLUE",
};

const RequiredFormLabel = (props) => {
  const { value, position, color } = props;

  return (
    <>
      {!position || position === AsteriskPositions.RIGHT ? value+" " : ""}
      <span
        className={
          !color || color === AsteriskColors.RED
            ? "red-asterisk"
            : "blue-asterisk"
        }
      >
        *
      </span>
      {position === AsteriskPositions.LEFT ? " "+value : ""}
    </>
  );
};

export {RequiredFormLabel, AsteriskPositions, AsteriskColors };
